import { FinancialStatementTypes, IFinancialStatementSource } from '@modeso/types__aumico-lib-annualreport-be';

export type FinancialStatementSourceMap = {
    [key in FinancialStatementTypes]: IFinancialStatementSource;
};
